import React, { useContext, useEffect, useState } from "react";
import { APIContext } from "../../../Contexts/APIContext";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { InputProps } from "../Interfaces/InputProps";
import { InputType } from "../Enums/InputType";
import AdvancedFiltersViewModel from "./Viewmodels/AdvancedFiltersViewModel";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";

interface IVulnerabilitiesFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AdvancedFiltersDialog({ open, setOpen, callTableViewModel, setCallTableViewModel }: IVulnerabilitiesFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [tags, setTags] = useState<string[]>([]);
    const [advancedFilters, setAdvancedFilters] = useState<AdvancedFiltersViewModel>(new AdvancedFiltersViewModel());

    useEffect(() => {
        if (open) {
            setAdvancedFilters(callTableViewModel.filters.advancedFilters)
        }
    }, [open])

    useEffect(() => {
        if (callTableViewModel.filters.client) {
            get('Search', `GetTagsDropdown`, (data) => setTags(data));
        }
    }, [callTableViewModel.filters.client])

    const inputProps: InputProps[] = [
        {
            name: 'tags',
            label: 'Tags',
            value: advancedFilters.tags,
            options: tags,
            type: InputType.AutoComplete
        },
        {
            name: 'isUnflaggedNC',
            label: 'Unflagged NC',
            value: advancedFilters.isUnflaggedNC,
            type: InputType.Checkbox
        },

    ];

    const getInput = (inputProps: InputProps) => {
        return (
            <Grid key={inputProps.name} size={12}>
                {
                    inputProps.type === InputType.Checkbox &&
                    <FormControlLabel
                        control={<Checkbox
                            name={inputProps.name}
                            onChange={(event, checkedState) => handleFilterCheckboxChange(inputProps.name, checkedState)}
                            checked={inputProps.value as boolean}
                        />}
                        label={inputProps.label}
                    />

                }
                {
                    inputProps.type === InputType.AutoComplete &&
                    <>
                        <InputLabel>{inputProps.label}</InputLabel>
                        <Autocomplete
                            multiple
                            fullWidth
                            options={inputProps.options!}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option}
                            value={inputProps.value as string[]}
                            onChange={(event: any, newValue: string[]) => { handleFilterChangeAutoComplete(inputProps.name, newValue) }}
                            limitTags={3}
                            renderOption={(props, option, { selected }) => {
                                const { ...optionProps } = props;
                                return (
                                    <li {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField {...params} fullWidth />
                            )}
                            renderTags={(value, getTagProps) => {
                                const numTags = value.length;
                                const limitTags = 1;
                                return (
                                    <>
                                        {value.slice(0, limitTags).map((option, index) => (
                                            <Chip
                                                {...getTagProps({ index })}
                                                key={index}
                                                label={option}
                                            />
                                        ))}

                                        {numTags > limitTags && ` +${numTags - limitTags}`}
                                    </>
                                );
                            }}
                        />
                    </>
                }

            </Grid>)
    }

    const handleFilterCheckboxChange = (name: string, value: boolean) => {
        setAdvancedFilters({
            ...advancedFilters,
            [name]: value
        })
    }

    const handleFilterChangeAutoComplete = (name: string, value: string[]) => {
        setAdvancedFilters({
            ...advancedFilters,
            [name]: value
        })
    }

    const handleMuturalNuberExculsivity = (activeName: string, exculsiveName: string, value: number) => {
        if (value >= 0)
            setAdvancedFilters({
                ...advancedFilters,
                [activeName]: value,
                [exculsiveName]: 0
            })
    }

    const confirm = () => {
        const newCallTableViewModel = { ...callTableViewModel };

        newCallTableViewModel.filters.advancedFilters = advancedFilters;

        setCallTableViewModel({
            ...newCallTableViewModel
        })

        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm">
            <DialogTitle>Advanced Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    {
                        inputProps.map(props => getInput(props))
                    }
                    <Grid container size={12}>
                        <InputLabel>Random Selection</InputLabel>
                        <TextField
                            disabled={advancedFilters.randomAgentSelection > 0}
                            type="number"
                            name='randomSelection'
                            onChange={(num) =>
                                handleMuturalNuberExculsivity(
                                    'randomSelection',
                                    'randomAgentSelection',
                                    num.target.value as unknown as number)}
                            value={advancedFilters.randomSelection}
                            fullWidth
                        />
                    </Grid>
                    <Grid container size={12}>
                        <InputLabel>Random Agent Selection</InputLabel>
                        <TextField
                            disabled={advancedFilters.randomSelection > 0}
                            type="number"
                            name='randomAgentSelection'
                            onChange={(num) =>
                                handleMuturalNuberExculsivity(
                                    'randomAgentSelection',
                                    'randomSelection',
                                    num.target.value as unknown as number)}
                            value={advancedFilters.randomAgentSelection}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}